import { Injectable } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import { Observable, tap } from 'rxjs';

// Actions
import { LoadAnalytics, ResetAnalytics } from './analytics.actions';

// Models
import { AnalyticsModel, AnalyticsPeriodDTO } from '@app/models/analytics.model';

// Services
import { IncidentsService } from '@app/services/incidents/incidents.service';
import { defaultAnalyticsSearchFilters } from '@app/types/analytics-filters';

export interface AnalyticsStateModel {
  analyticsPeriodA?: AnalyticsPeriodDTO;
  analyticsPeriodB?: AnalyticsPeriodDTO;
}

@State<AnalyticsStateModel>({
  name: 'incidentAnalytics',
  defaults: {
    analyticsPeriodA: void 0,
    analyticsPeriodB: void 0,
  },
})
@Injectable()
export class IncidentAnalyticsState {
  constructor(private incidentsService: IncidentsService) {}

  @Selector()
  static getIncidentAnalytics(state: AnalyticsStateModel): AnalyticsStateModel {
    return {
      analyticsPeriodA: state.analyticsPeriodA,
      analyticsPeriodB: state.analyticsPeriodB,
    };
  }

  @Action(LoadAnalytics)
  loadIncidentAnalytics(ctx: StateContext<AnalyticsStateModel>, action: LoadAnalytics): Observable<AnalyticsModel> {
    const filters = action.payload?.filters ?? defaultAnalyticsSearchFilters;

    return this.incidentsService.getIncidentAnalytics(filters).pipe(
      tap((response) => {
        ctx.patchState({ ...response });
      }),
    );
  }

  @Action(ResetAnalytics)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  resetIncidentAnalytics(ctx: StateContext<AnalyticsStateModel>, action: ResetAnalytics): void {
    ctx.patchState({
      analyticsPeriodA: void 0,
      analyticsPeriodB: void 0,
    });
  }
}
